const PoliticaPrivacidad = () => {
  return (
    <div className="container my-5">
      {/* TÍTULO */}
      <div className="text-center mb-5">
        <h1 className="fw-bold">Política de Privacidad</h1>
        <p className="text-muted">Última actualización: 10/10/2024</p>
      </div>

      <div className="card shadow-sm border-0">
        <div className="card-body p-4 p-md-5">

          <h5 className="fw-bold">1. Datos personales recopilados</h5>
          <p>
            MarketLuz recopila datos personales como nombre completo, correo
            electrónico, número telefónico, dirección de entrega y datos
            necesarios para la creación de cuentas y procesamiento de pedidos.
          </p>

          <h5 className="fw-bold mt-4">2. Finalidad del uso de datos</h5>
          <ul>
            <li>Procesar compras y pedidos</li>
            <li>Gestionar pagos y envíos</li>
            <li>Atención al cliente</li>
            <li>Mejorar la experiencia del usuario</li>
          </ul>

          <h5 className="fw-bold mt-4">3. Seguridad de la información</h5>
          <p>
            MarketLuz adopta medidas técnicas y organizativas razonables para
            proteger los datos personales frente a accesos no autorizados,
            pérdida o uso indebido.
          </p>

          <h5 className="fw-bold mt-4">4. Datos de pago</h5>
          <p>
            MarketLuz <strong>no almacena información de tarjetas</strong>.
            Los pagos son procesados por pasarelas de pago certificadas como
            Culqi, cumpliendo estándares de seguridad.
          </p>

          <h5 className="fw-bold mt-4">5. Cumplimiento legal</h5>
          <p>
            Esta política cumple con la Ley N° 29733 – Ley de Protección de Datos
            Personales y su reglamento, vigente en la República del Perú.
          </p>

        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidad;
